export default __webpack_public_path__ + "static/hardOn-5e77f00aa67c80eaca6fa7f2260ed455.svg";